/**
 * digitaleAbgabe_controls
 * @param factoryID
 * @param betriebsleiterID
 * @param dateFrom
 * @param dateTo
 * @param area
 * @param jsonRecords
 */
window.digitaleAbgabe_controls = function(factoryID, betriebsleiterID, dateFrom, dateTo, area, jsonRecords) {
  const fehlerhafteRecordsElement = $('#fehlerhafteRecords');
  const forwardButtonElement = $('#forwardButton');
  const hasErrors = $('#has-errors');
  const titleControl = $('#check-controls');
  const jsonObject = JSON.parse(jsonRecords);

  forwardButtonElement.attr('disabled', true);

  const areas = [
    'pflanzenschutz',
    'duengung',
    'herbizid',
    'verwirrung',
    'andere_massnahmen',
    'bewaesserung',
    'digitaleAbgabe',
  ];

  const queue = [];
  Array.prototype.forEach.call(areas, function(element) {
    if (typeof jsonObject[element] !== 'undefined' && jsonObject[element].length > 0) {
      $.each(jsonObject[element], function(k, recordID) {
        queue.push({
          'area': element,
          'recordID': recordID,
          'call': '?area=' + element + '&record=' + recordID,
        });
      });
    } else if (element === 'digitaleAbgabe') {
      queue.push({
        'area': element,
        'call': '?area=' + element,
      });
    }
  });

  let self = this;
  const resultTotal = {};

  /**
   * getNextAreaResult
   * @param queueIndex
   * @returns {boolean}
   */
  this.getNextQueueResult = function(queueIndex) {
    if (typeof queue[queueIndex] === 'undefined') {
      return false;
    }

    let htmlString = Math.round((queueIndex + 1) / queue.length * 100) + '% (';
    htmlString += LANG_STRINGS[queue[queueIndex].area];
    if (typeof queue[queueIndex].recordID !== 'undefined') {
      htmlString += '  [' + queue[queueIndex].recordID + ']';
    }
    htmlString += ')';

    titleControl.find('span.area').html(' ' + htmlString + '');

    $.ajax({
      url: BASE_PATH + 'ajax/helper/druckAbgabe/ajax.checkRecordsControlByFactory' + queue[queueIndex].call,
      type: 'post',
      dataType: 'json',
      data: {
        factoryID: factoryID,
        betriebsleiterID: betriebsleiterID,
        dateFrom: dateFrom,
        dateTo: dateTo,
        abgabeArea: area,
      },
      beforeSend: function() {
        insertAutoLoader(fehlerhafteRecordsElement);
      },
      success: function(result) {
        $.extend(resultTotal, result);

        if (typeof queue[queueIndex + 1] === 'undefined') {
          self.finishResult(resultTotal);
        } else {
          self.getNextQueueResult(queueIndex + 1);
        }
      },
      error: function(jqXHR, textStatus, errorThrown) {
        fehlerhafteRecordsElement.html('<article class="message message--danger"><div class="message__body">' + LANG_STRINGS.errorMessage + ' <small>(' + jqXHR.status + ' ' + errorThrown + ')</small></div></article>');
      },
    });
  };

  /**
   * finishResult
   * @param resultTotal
   */
  this.finishResult = function(resultTotal) {
    $.ajax({
      url: BASE_PATH + 'ajax/list/druckAbgabe/ajax.abgabeFehlerhafteRecords',
      type: 'post',
      data: {
        results: resultTotal,
        abgabeArea: area,
        factoryID: factoryID,
        betriebsleiterID: betriebsleiterID,
      },
      success: function(res) {
        if (Object.keys(resultTotal).length === 0) {
          forwardButtonElement.removeAttr('disabled');
        } else {
          hasErrors.val(1);
        }
        fehlerhafteRecordsElement.html(res).show();
      },
      error: function(jqXHR, textStatus, errorThrown) {
        fehlerhafteRecordsElement.html('<article class="message message--danger"><div class="message__body">' + LANG_STRINGS.errorMessage + ' <small>(' + jqXHR.status + ' ' + errorThrown + ')</small></div></article>');
      },
    });
  };

  this.getNextQueueResult(0);
};